import axiosInstance from "../../axiosInstance";

const BASE = "/elearning/certificates";

export const getCertificateTypes = async () => {
  const res = await axiosInstance.get(`${BASE}/types`);
  return res.data;
};

export const getCertificateTemplates = async (recipientType = "all") => {
  const res = await axiosInstance.get(`${BASE}/templates`, {
    params: recipientType !== "all" ? { recipient_type: recipientType } : {},
  });
  return res.data;
};

export const createCertificateTemplate = async (data) => {
  const res = await axiosInstance.post(`${BASE}/templates`, data);
  return res.data;
};

export const updateCertificateTemplate = async (id, data) => {
  const res = await axiosInstance.put(`${BASE}/templates/${id}`, data);
  return res.data;
};

export const deleteCertificateTemplate = async (id) => {
  const res = await axiosInstance.delete(`${BASE}/templates/${id}`);
  return res.data;
};

export const copyCertificateTemplate = async (id, data = {}) => {
  const res = await axiosInstance.post(`${BASE}/templates/${id}/copy`, data);
  return res.data;
};

/** Upload ảnh nền biểu mẫu (multipart) — trả về { url } */
export const uploadCertificateTemplateBackground = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axiosInstance.post(`${BASE}/templates/background`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getStudentRecipients = async (keyword = "") => {
  const res = await axiosInstance.get(`${BASE}/recipients/students`, {
    params: keyword ? { keyword } : {},
  });
  return res.data;
};

export const getTeacherRecipients = async (keyword = "") => {
  const res = await axiosInstance.get(`${BASE}/recipients/teachers`, {
    params: keyword ? { keyword } : {},
  });
  return res.data;
};

export const getCertificates = async (params = {}) => {
  const res = await axiosInstance.get(BASE, { params });
  return res.data;
};

export const getCertificateExportLogs = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE}/export-logs`, { params });
  return res.data;
};

export const getCertificateById = async (id) => {
  const res = await axiosInstance.get(`${BASE}/${id}`);
  return res.data;
};

/** Xuất PDF gộp hoặc ZIP ảnh (backend Puppeteer) */
export const exportCertificates = async (ids, format = "pdf", requestConfig = {}) => {
  const res = await axiosInstance.post(
    `${BASE}/export`,
    { ids, format },
    { responseType: "blob", ...requestConfig }
  );
  return res;
};

export const issueCertificate = async (data) => {
  const res = await axiosInstance.post(BASE, data);
  return res.data;
};

export const deleteCertificate = async (id, body = {}) => {
  const res = await axiosInstance.delete(`${BASE}/${id}`, { data: body });
  return res.data;
};
